import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService, GetPigeonsParams } from './api.service';
import { Pigeon } from '../../domain/pigeon';

@Injectable({ providedIn: 'root' })
export class PigeonCacheService {
    private readonly api = inject(ApiService);
    private readonly cache = new Map<string, { data: Pigeon[]; fetchedAt: number }>();
    private readonly TTL_MS = 60_000;
    private readonly PAST_DATE_TTL_MS = 3_600_000;

    getPigeons(params?: GetPigeonsParams): Observable<Pigeon[]> {
        const key = `${params?.showInactive ?? false}:${params?.selectedDate ?? ''}`;
        const cached = this.cache.get(key);
        const isPastDate = !!params?.selectedDate && params.selectedDate !== this.todayBackendDate();
        const ttl = isPastDate ? this.PAST_DATE_TTL_MS : this.TTL_MS;

        if (cached && Date.now() - cached.fetchedAt < ttl) {
            return of(cached.data);
        }
        return this.api.getPigeons(params).pipe(
            tap(data => { this.cache.set(key, { data, fetchedAt: Date.now() }); }),
        );
    }

    invalidate(): void {
        const today = this.todayBackendDate();
        for (const key of this.cache.keys()) {
            const dateSegment = key.split(':')[1] ?? '';
            if (!dateSegment || dateSegment === today) {
                this.cache.delete(key);
            }
        }
    }

    private todayBackendDate(): string {
        const nz = new Date().toLocaleDateString('en-NZ', { timeZone: 'Pacific/Auckland' });
        const [d, m, y] = nz.split('/');
        return `${y}-${parseInt(m)}-${parseInt(d)}`;
    }
}
